/**
 * 认证相关工具函数
 */
import { getAccessToken, isAuthenticated } from './storage'

/**
 * 检查是否需要登录
 * 如果没有token，跳转到登录页
 * @param {Object} vm - Vue实例
 * @param {string} message - 提示消息
 * @returns {boolean} 是否已登录
 */
export function requireAuth(vm, message = '请先登录') {
  if (!isAuthenticated()) {
    vm.$message && vm.$message({
      message,
      type: 'warning',
    })
    if (vm.$router) {
      vm.$router.push({ name: 'login' })
    }
    return false
  }
  return true
}

/**
 * 检查token是否存在
 * @param {Object} vm - Vue实例（可选）
 * @returns {boolean}
 */
export function checkToken(vm = null) {
  const token = getAccessToken()
  if (!token) {
    if (vm) {
      requireAuth(vm)
    }
    return false
  }
  return true
}

/**
 * 获取Authorization header
 * @returns {Object} { Authorization: 'Bearer <token>' }
 */
export function getAuthHeaders() {
  const token = getAccessToken()
  if (!token) {
    return {}
  }
  return {
    Authorization: `Bearer ${token}`
  }
}

